import axios from 'axios';
import { buildAgentPath } from '../../helpers';
import { handleErrors, headerBuilder, paramBuilder } from '../http';

var validateOptions = function validateOptions(functionName, requiredOptions, options) {
  var validTypes = ['bridge', 'filestore', 'handler'];
  var invalidType = !validTypes.includes(options.type);
  var missing = requiredOptions.filter(function (requiredOption) {
    return !options[requiredOption];
  });

  if (missing.length > 0) {
    throw new Error("".concat(functionName, " failed! The following required options are missing: ").concat(missing));
  }

  if (invalidType) {
    throw new Error("".concat(functionName, " failed! The provided adapter type (").concat(options.attributeType, ") is not valid. Must be one of ").concat(validTypes.join(', ')));
  }
};

export var fetchAdapters = function fetchAdapters() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('fetchAdapters', ['type'], options);
  return axios.get("".concat(options.slug ? '/app/system-coordinator/components/agent' : buildAgentPath(options), "/app/api/v1/adapters?type=").concat(options.type), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      adapters: response.data.adapters
    };
  })["catch"](handleErrors);
};